import styled from '@emotion/styled';

import { tokens, Stack, OptionCard } from '@hotjar/hotsauce';
import type { FeedbackDisplayType } from '@hotjar/feedback/domain/IncomingFeedback/Type';
import { DISPLAY_LABELS } from '@hotjar/feedback/domain/IncomingFeedback/Type';
import { useTranslationWithPrefix } from '@hotjar/translations';
import { useFeatureFlag } from '@hotjar/feature-flags';
import buttonImg from './images/feedback-button.svg';
import embeddedImg from './images/feedback-embedded.svg';

const StyledStack = styled(Stack)`
  padding: ${tokens.spacer.x2} ${tokens.spacer.x7};
`;

const StyledOptionCard = styled(OptionCard)`
  cursor: pointer;
  max-width: 180px;
  height: 180px;
  justify-content: flex-start;
  & > span:first-of-type {
    width: ${tokens.spacer.x8};
    height: ${tokens.spacer.x4pt5};
  }
`;

export interface FeedbackTypeProps {
  displayType: FeedbackDisplayType;
  onChange: (newDisplayType: FeedbackDisplayType) => void;
}

export function FeedbackType({ displayType = 'button', onChange }: FeedbackTypeProps): JSX.Element {
  const { t } = useTranslationWithPrefix('feedback:wizard.section.type');
  const hasEmbeddableWidgets = useFeatureFlag('feedback.embeddable_widget');

  return (
    <StyledStack spacing="x3">
      <StyledOptionCard
        name="feedback_type"
        kind="single-select"
        title={t(`${DISPLAY_LABELS.button}.label`)}
        value="button"
        onChange={() => onChange('button')}
        isChecked={displayType === 'button'}
        description={t('button.description')}
        illustration={buttonImg}
      />
      <StyledOptionCard
        name="feedback_type"
        kind="single-select"
        title={t(`${DISPLAY_LABELS.inline}.label`)}
        value="inline"
        onChange={() => onChange('inline')}
        isChecked={displayType === 'inline'}
        description={t('embedded.description')}
        illustration={embeddedImg}
        badge="beta"
        isDisabled={!hasEmbeddableWidgets}
      />
    </StyledStack>
  );
}
